import { EventMeta } from '../../../interfaces/meta.interface';

type MailItemsAccessedFields = {
    riskyKeyword: boolean;
};

const updateInboxRules: EventMeta<MailItemsAccessedFields> = {
    title: 'Inbox Rules Updated.',
    default: {
        description: 'Inbox Rules Updated.',
        longDescription:
            'A mailbox owner or other user with access to the mailbox modified an inbox rule in the Outlook client.',
        severity: 'info',
    },
    classifications: [
        {
            severity: 'critical',
            description: (fields) => `A suspicious IP attempted to update an inbox rule`,
            longDescription: (fields) =>
                `An inbox rule was updated from a mailbox by a suspicious IP address that is not in your allowed list. This activity could indicate an attempt to modify email handling or bypass automated protections.`,
            predicates: {
                isAllowedASN: false,
                isAllowedCountry: false,
                isAllowedRegion: false,
                isAllowedIP: false,
                isFraudulentIP: true,
                isMicrosoftActivity: false,
            },
        },
        {
            severity: 'danger',
            description: (fields) => `An unapproved IP attempted to update an inbox rule`,
            longDescription: (fields) =>
                `An inbox rule was updated from a mailbox by an IP address that is not in your allowed list. This activity may indicate an attempt to modify email handling or circumvent automated protections.`,
            predicates: {
                isAllowedASN: false,
                isAllowedCountry: false,
                isAllowedRegion: false,
                isAllowedIP: false,
                isMicrosoftActivity: false,
            },
        },
        {
            severity: 'warning',
            description: (fields) => `A suspicious IP updated an inbox rule`,
            longDescription: (fields) =>
                `An inbox rule was updated. The action originated from a suspicious IP. While updating inbox rules can be a normal user or admin activity, changes from suspicious IPs are unusual and may indicate tampering intended to redirect or conceal emails. Review the rule update to confirm whether it was expected or potentially unauthorized.`,
            predicates: {
                isFraudulentIP: true,
            },
        },
        {
            severity: 'info',
            description: (fields) => `An inbox rule was updated`,
            longDescription: (fields) =>
                `An inbox rule was updated. This is an informational record of a mailbox configuration change. No unusual conditions were associated with this entry. It does not require immediate action unless the update to the inbox rule was unexpected.`,
            predicates: {
                isMicrosoftActivity: true,
            },
        },
        {
            severity: 'info',
            description: (fields) => `An inbox rule was updated`,
            longDescription: (fields) =>
                `An inbox rule was updated. This is an informational record of a mailbox configuration change. No unusual conditions were associated with this entry. It does not require immediate action unless the update to the inbox rule was unexpected.`,
        },
    ],
};

export default updateInboxRules;
